import React, { createContext, useEffect, useState, useContext } from "react";
import ReactDOM from "react-dom";
import { Systemomrade } from "@generated/types";
import { Systemmelding } from "./systemmelding";

interface SystemmeldingContextType {
	systemomrade: Systemomrade | null;
	setSystemomrade: (omrade: Systemomrade | null) => void;
}

const SystemmeldingContext = createContext<SystemmeldingContextType | undefined>(undefined);
interface Props {
	getSystemmeldingerRequestFunction: (systemomrade: Systemomrade) => Promise<string[]>;
	children: React.ReactNode;
}
export const SystemmeldingProvider: React.FC<Props> = props => {
	const [systemomrade, setSystemomrade] = useState<Systemomrade | null>(null);
	const [systemmeldinger, setSystemmeldinger] = useState<string[]>([]);

	const updateSystemomrade = (omrade: Systemomrade | null) => {
		if (omrade === null || omrade === undefined) {
			setSystemmeldinger([]);
		}
		setSystemomrade(omrade);
	};

	const getSystemmeldinger = async (omrade: Systemomrade) => {
		props
			.getSystemmeldingerRequestFunction(omrade)
			.then(result => setSystemmeldinger(result))
			.catch(_ => setSystemmeldinger([]));
	};

	useEffect(() => {
		if (!props.getSystemmeldingerRequestFunction) {
			return;
		}
		if (systemomrade !== null) {
			getSystemmeldinger(systemomrade);
		}
	}, [systemomrade, props.getSystemmeldingerRequestFunction]);

	const SystemmeldingPortal: React.FC<{ systemmeldinger: string[] }> = props => {
		const targetElement = document.getElementById("show-systemmelding");
		if (!targetElement || !systemmeldinger) return null;

		return ReactDOM.createPortal(<Systemmelding systemmeldinger={props.systemmeldinger} />, targetElement);
	};

	return (
		<SystemmeldingContext.Provider value={{ systemomrade, setSystemomrade: updateSystemomrade }}>
			{props.children}
			<SystemmeldingPortal systemmeldinger={systemmeldinger} />
		</SystemmeldingContext.Provider>
	);
};

export const useSystemmelding = (): SystemmeldingContextType => {
	const context = useContext(SystemmeldingContext);
	if (!context) {
		throw new Error("useSystemmelding must be used within a SystemmeldingProvider");
	}
	return context;
};
